module.exports = __webpack_public_path__ + "img/0S6A0073.39f81c13.jpg";